export interface VersionInfo {
    commitHash: string
    tag: string
}

declare const COMMIT_HASH: string
declare const RELEASE_TAG: string

export const VersionConfig = {
    commitHash: COMMIT_HASH,
    tag: RELEASE_TAG,
}
